import { FC } from 'react';
import { PageContainer } from '@edikk-edikk/country-layout-black';
import { CardLocationHeader } from '#home/components/card-location/CardLocationHeader';
import { CardLocationBody } from '#home/components/card-location/CardLocationBody';
import { useBaseContext } from '#base/hooks/use-base-context';
import CardCss from '#srcCssModules/card/card.module.scss';
import homeContentCss from '#srcCssModules/home/home-content.module.scss';

const CardLocation: FC = () => {
  const { hasCityList, isSingleCity } = useBaseContext();

  if (!hasCityList || isSingleCity) {
    return null;
  }

  return (
    <PageContainer additionalClassName={homeContentCss.homeContent__cardHolder}>
      <div className={CardCss.card}>
        <CardLocationHeader />
        <CardLocationBody />
      </div>
    </PageContainer>
  );
};

export { CardLocation };
